import { render } from "./RoutesList.vue?vue&type=template&id=627c7f58&scoped=true"
import script from "./RoutesList.vue?vue&type=script&lang=js"
export * from "./RoutesList.vue?vue&type=script&lang=js"

import "./RoutesList.vue?vue&type=style&index=0&id=627c7f58&lang=scss&scoped=true"

import exportComponent from "/Users/fabiankala/Documents/projects/jan-art/jan-art-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-627c7f58"]])

export default __exports__